import app from '../app';

import { VueToastr } from "vue-toastr";
import "vue-toastr/dist/style.css";

app.use(VueToastr, {
    /* OverWrite Plugin Options if you need */
    defaultTimeout: 3000,
    defaultPosition: "toast-top-right",
    defaultClassNames: ["vueToaster"]
    //defaultClassNames: ["animate__animated", "animate__slideInRight", "vueToaster"]
});


/**
 * Components
 *   1. Component name prefix should "app"-component-name
 * */
app.component('app-input', require('./components/input/Index').default);
app.component('app-pre-loader', require('./components/preloders/Preloader').default);
app.component('app-overlay-loader', require('./components/preloders/OverlayLoader').default);
app.component('app-modal', require('./components/modal/Modal').default);
app.component('app-table', require('./components/datatable/Index').default);
app.component('app-load-more', require('./components/buttons/LoadMore').default);
app.component('app-pagination', require('./components/buttons/Pagination').default);
app.component('app-filter', require('./components/filter/Index').default);
app.component('app-search', require('./components/datatable/Search').default);
app.component('app-tab-filter', require('./components/filter/TabFilter').default);
app.component('app-icon', require('./components/icon/Icon').default);
app.component('app-avatar', require('./components/avatars/Avatar').default);
app.component('app-avatars-group', require('./components/avatars-group/AvatarsGroup').default);
app.component('app-tab', require('./components/tabs/Index').default);
app.component('app-custom-tab', require('./components/custom-tabs/Index').default);
app.component('app-form-wizard', require('./components/form-wizard/FormWizard').default);
app.component('app-button', require('./components/buttons/AppButton').default);
app.component('app-breadcrumb', require('./components/breadcrumb/index').default);
app.component('app-badge', require('./components/badge/Badge').default);
app.component('app-card-view', require('./components/card-view/index').default);
app.component('app-template-preview-card', require('./components/template-preview-card/AppTemplatePreviewCard').default);
app.component('app-note', require('./components/badge/Note').default);
app.component("app-chart", require('./components/charts/Index').default);
app.component("app-dropdown-menu", require('./components/buttons/DropdownMenu').default);
app.component("app-navbar", require('./components/layouts/Navbar').default);
app.component("app-navbar-language-dropdown", require('./components/layouts/navbar-dropdowns/LanguageDropdown').default);
app.component("app-navbar-notification-dropdown", require('./components/layouts/navbar-dropdowns/NotificationDropdown').default);
app.component("app-navbar-profile-dropdown", require('./components/layouts/navbar-dropdowns/ProfileDropdown').default);
app.component("app-widget", require('./components/dashboard-widget/Index').default);
app.component("app-confirmation-modal", require('./components/confirmation-modal/Index').default);
app.component("app-empty-data-block", require('./components/datatable/EmptyData').default);
app.component("app-media-object", require('./components/media-object/MediaObject').default);
app.component("app-error", require('./components/error-page/Error').default);
app.component("app-calendar", require('./components/calendar/Calendar').default);
app.component("app-filter-with-search", require('./components/filter/FilterWithSearch').default);
app.component("app-submit-button", require('./components/buttons/SubmitButton').default);
app.component("app-organization-chart", require('./components/organization-chart/OrganizationChart').default);
app.component("app-tag-manager", require('./components/tag/TagManager').default);

//Sidebar
app.component('sidebar', require('./components/layouts/Sidebar').default);

/**
 * v-calendar (v3) — plugin setup + date-picker / calendar components.
 * The old `v-calendar/lib/components/*.umd` entry points were removed in v3;
 * components are now named exports and the plugin configures global options.
 * */
import { setupCalendar, Calendar, DatePicker } from 'v-calendar';
import 'v-calendar/dist/style.css';

app.use(setupCalendar, {});
// Keep the historical kebab-case tag names used across the templates.
app.component('v-calendar', Calendar);
app.component('v-date-picker', DatePicker);

/**
 * An EventHub to share events between components.
 * Vue 3 instances no longer expose $on/$off/$once, so we use a tiny emitter
 * that preserves the same API (see EventBus.js).
 * */
import EventBus from "./helpers/EventBus";
app.config.globalProperties.$hub = new EventBus();

/**
 * cookies
 */

import AppCookie from "./helpers/cookies/AppCookies";
window.AppCookie = AppCookie;
